import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div
      className="min-h-screen px-4 py-8"
      style={{
        background: "linear-gradient(160deg, #0d1f1f 0%, #1a2f2f 40%, #0f1a1a 100%)",
        fontFamily: "Noto Sans JP, sans-serif",
      }}
    >
      <div className="max-w-2xl mx-auto space-y-5">
        <h1 className="text-xl font-bold" style={{ color: "#f4e5c3", fontFamily: "Montserrat, sans-serif" }}>
          利用規約
        </h1>
        <div
          className="rounded-2xl p-4 text-sm leading-relaxed space-y-3"
          style={{
            background: "rgba(212,175,55,0.06)",
            border: "1px solid rgba(212,175,55,0.22)",
            color: "rgba(244,229,195,0.88)",
          }}
        >
          <p>本アプリは、会員管理およびポイント・スタンプサービスの提供を目的として運用します。</p>
          <p>不正利用や第三者になりすます行為、サービス運営を妨げる行為を禁止します。</p>
          <p>システム保守や障害により、予告なくサービス内容を変更・停止する場合があります。</p>
          <p>本規約は必要に応じて改定され、改定後は本アプリ上の表示をもって効力を生じます。</p>
        </div>
        <Link to="/register" className="text-xs underline" style={{ color: "rgba(212,175,55,0.9)" }}>
          登録画面へ戻る
        </Link>
      </div>
    </div>
  );
}
